import { RawLines } from "../RawLines";

export const HeaderPaywallCustomizationLine = () => (
  <RawLines.HeaderPaywallCustomizationLine />
);
